/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IDoctor } from 'app/shared/model/doctor.model';
import { IEspecialty } from 'app/shared/model/especialty.model';

export interface IDoctorEspecialty {
  id?: string;
  departmentCode?: string;
  active?: boolean | null;
  createdDtm?: number | null;
  createdBy?: string | null;
  modifiedBy?: string | null;
  joiningDt?: number | null;
  leavingDt?: number | null;
  consultationCharge?: number | null;
  followupCharge?: number;
  followupDay?: number | null;
  followupVisit?: number | null;
  timestampentry?: number;
  microSec?: number;
  lastupdated?: number;
  cursor?: number;
  doctorId?: IDoctor;
  especialtyCode?: IEspecialty;
}

export const defaultValue: Readonly<IDoctorEspecialty> = {
  active: false,
};
